export const RETURN_TYPE_ARR = [
  { key: 'ONLY_BACK', value: 1, cn_name: '仅退款', },
  { key: 'RETURNS_AND_REFUNDS', value: 2, cn_name: '退货退款', },
  { key: 'EXCHANGE_GOODS', value: 3, cn_name: '换货', },
]
export const RETURN_TYPE_RESULT = RETURN_TYPE_ARR.reduce((total,item)=>{
  total[item.key] = item.value
  return total
},{})
export const RETURN_STATUS_ARR = [
  { key: 'IN_REVIEW', value: 0, cn_name: '审核中', },
  { key: 'REVIEW_FAILED', value: -1, cn_name: '审核失败', },
  { key: 'RETURNING_GOODS', value: 1, cn_name: '退货中', },
  { key: 'SHIPPED', value: 2, cn_name: '已发货', },
  { key: 'RECEIVED_GOODS', value: 3, cn_name: '已收货', },
  { key: 'RETURN_COMPLETED', value: 4, cn_name: '退货完成', },
]
export const RETURN_STATUS_RESULT = RETURN_STATUS_ARR.reduce((total,item)=>{
  total[item.key] = item.value
  return total
},{})
export const CHANGE_GOODS_STATUS_ARR = [
  { key: 'NONE', value: 0, cn_name: '代发货或者没有', },
  { key: 'RETURNING', value: 1, cn_name: '退货中', },
  { key: 'RECEIVED', value: 2, cn_name: '已收货', },
]
export const CHANGE_GOODS_STATUS_RESULT = CHANGE_GOODS_STATUS_ARR.reduce((total,item)=>{
  total[item.key] = item.value
  return total
},{})